import WeixinLogo from '/public/images/logo/weixinLogo.svg';
import QiWeiLogo from '/public/images/logo/qiweiLogo.svg';
// import RedNoteLogo from '/public/images/logo/redNoteLogo.svg';
// import DouyinLogo from '/public/images/logo/douyinLogo.svg';
// import WeiboLogo from '/public/images/logo/weiboLogo.svg';
// import ShipinLogo from '/public/images/logo/shipinLogo.svg';
// import LinkInLogo from '/public/images/logo/linkInLogo.svg';

export const MediaLogo = [
  {
    logo: WeixinLogo,
    codeUrl: '/images/logo/weixinQRCode.png',
  },
  {
    logo: QiWeiLogo,
    codeUrl: '/images/logo/qiweiQRCode.png',
  },
];

export const NavFooter = [
  {
    title: '产品与服务',
    navItem: [
      // {
      //   subTitle: '价格',
      //   url: '/pricing',
      // },
      // {
      //   subTitle: '出海调研与评估',
      //   url: '/products/overseas-expansion-research-and-evaluation',
      // },
      // {
      //   subTitle: '出海战略规划',
      //   url: '/products/overseas-strategy-planning',
      // },
      // {
      //   subTitle: '全球人力战略咨询',
      //   url: '/products/global-work-force-strategy-consulting',
      // },
      // {
      //   subTitle: '全球人力资源管理',
      //   url: '/products/global-hr-management',
      // },
      {
        subTitle: '名义雇主/EOR',
        url: '/products/eor',
      },
      {
        subTitle: '全球灵活用工/Contractor',
        url: '/products/contractor',
      },
      {
        subTitle: '共享HR/PEO',
        url: '/products/shared-hr-services',
      },
      // {
      //   subTitle: '人才猎聘',
      //   url: '/products/talent-recruitment',
      // },
      {
        subTitle: '全球工作签证',
        url: '/products/global-visa',
      },
      {
        subTitle: '全球薪酬管理',
        url: '/products/global-payroll',
      },
      // {
      //   subTitle: '海外公司注册及秘书服务',
      //   url: '/products/overseas-company-registration-and-secretarial-services',
      // },
      // {
      //   subTitle: '全球合规咨询服务',
      //   url: '/products/global-compliance-advisory-services',
      // },
      // {
      //   subTitle: '业务流程外包/BPO',
      //   url: '/products/business-process-outsourcing-bpo',
      // },
      // {
      //   subTitle: '海外人力外包/HRO',
      //   url: '/products/overseas-human-resources-outsourcing-hro',
      // },
      {
        subTitle: '全球人力资源管理平台',
        url: '/products/global-human-resource-management-platform',
      },
    ],
  },
  {
    title: '解决方案',
    navItem: [
      {
        subTitle: '全球扩张',
        url: '/solutions/global-expansion',
      },
      {
        subTitle: '全球合规',
        url: '/solutions/compliant',
      },
      {
        subTitle: '入职与算薪',
        url: '/solutions/onboarding',
      },
    ],
  },
  {
    title: '资源中心',
    navItem: [
      {
        subTitle: '雇佣指南',
        url: '/employment-guides',
      },
      {
        subTitle: '成本计算器',
        url: '/tools/cost-calculator',
      },
      // {
      //   subTitle: '客户案例',
      //   url: '/',
      // },
    ],
  },
  // {
  //   title: '新闻资讯',
  //   navItem: [
  //     {
  //       subTitle: '行业文章',
  //       url: '/',
  //     },
  //     {
  //       subTitle: '专家互动论坛',
  //       url: '/',
  //     },
  //   ],
  // },
  {
    title: '公司',
    navItem: [
      {
        subTitle: '关于我们',
        url: '/about-us',
      },
      {
        subTitle: '加入我们',
        url: '/careers',
      },
      // {
      //   subTitle: '新闻活动',
      //   url: '/',
      // },
      // {
      //   subTitle: '品牌活动',
      //   url: '/',
      // },
      // {
      //   subTitle: '联系我们',
      //   url: '/',
      // },
    ],
  },
];
